// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
/**
 * 团购列表上的横向滚动条
 */

import cateSelect from './components/group-cate-select/group-cate-select.vue'
/**
 * 商品轮播图
 */
import goodsSlideShow from './components/goods-slide-show/goods-slide-show.vue'
/**
 * 团购详情页中的 参团
 */
import groupDetailJoin from './components/group-detail-join/group-detail-join.vue'
/**
 * 团购详情页中的倒计时
 */
import groupCountdown from './components/group-countdown/group-countdown.vue'
/**
 * 商品详情页中的规格选择
 */
import goodsSpecSelect from './components/goods-spec-select/goods-spec-select.vue'
/**
 * 商品详情页中的活动区域
 */
import goodsPromotion from './components/goods-promotion/goods-promotion.vue'
/**
 * 商品详情页中的代金卷区域
 */
import goodsVoucher from './components/goods-voucher/goods-voucher.vue'
/**
 * 商品详情页中的地区选择
 */
import goodsAreaSelect from './components/goods-area-select/goods-area-select.vue'
/**
 * 商品详情页中的评价（简短）
 */
import goodsEval from './components/goods-evaluate/goods-evaluate.vue'
/**
 * 商品详情页中的店铺信息
 */
import goodsStoreInfo from './components/goods-store-info/goods-store-info.vue'
/**
 * 商品详情页中的全部评价
 */
import goodsEvalAll from './components/goods-eval-all/goods-eval-all.vue'
/**
 * 商品详情页中的批发规格选择
 */
import goodsWholesaleSpecSelect from './components/goods-wholesale-spec-select/goods-wholesale-spec-select.vue'
/**
 * 商品详情页中的店铺推荐
 */
import goodsStoreRecommend from './components/goods-store-recommend/goods-store-recommend.vue'
/**
 * 商品详情页中的推荐组合
 */
import goodsCombo from './components/goods-combo/goods-combo.vue'
/**
 * 商品详情页中的优惠套装
 */
import goodsBundling from './components/goods-bundling/goods-bundling.vue'

/**
 * 商品详情页中的咨询
 */
import goodsConsult from './components/goods-consult/goods-consult.vue'
/**
 * 商品详情页中的预售
 */
import goodsbook from './components/goods-book/goods-book.vue'


/**
 * 商品详情页中的限时折扣
 */
import goodsDiscount from './components/goods-discount/goods-discount.vue'
/**
 * 购买流程中所需要的地址选择
 */
import buyAddress from './components/buy-address/buy-address.vue'
/**
 * 一个简单的地区选择
 */
import areaSelectNormal from './components/area-select-normal/area-select-normal.vue'
/**
 * 商品详情页的消保服务
 */
import goodsContract from './components/goods-contract/goods-contract.vue'
/**
 * 购买流程中所需要的支付方式选择
 */
import buyPayment from './components/buy-payment/buy-payment.vue'
/**
 * 购买流程中所需要的发票选择
 */
import buyInvoice from './components/buy-invoice/buy-invoice.vue'

/**
 * 商品详情页中的门店显示
 */
import goodsChain from './components/goods-chain/goods-chain.vue'
/**
 *收藏中的商品规格reselect选择
 */
import goodsReselect from './base-components/goods-reselect/goods-reselect.vue'
/**
 *收藏中的批发商品规格选择
 */
import goodsReselectWholesale from './base-components/goods-reselect-wholesale/goods-reselect-wholesale.vue'

/**
 * 全局filter
 */
import filterInit from './util/filter'


filterInit(Vue);

Vue.component('nc-cate-select', cateSelect)
Vue.component('nc-goods-slide-show', goodsSlideShow)
Vue.component('nc-group-detail-join', groupDetailJoin)
Vue.component('nc-group-count-down', groupCountdown)
Vue.component('nc-goods-spec-select', goodsSpecSelect)
Vue.component('nc-goods-promotion', goodsPromotion)
Vue.component('nc-goods-voucher', goodsVoucher)
Vue.component('nc-goods-area-select', goodsAreaSelect)
Vue.component('nc-goods-evaluate', goodsEval)
Vue.component('nc-goods-store-info', goodsStoreInfo)
Vue.component('nc-goods-eval-all', goodsEvalAll)
Vue.component('nc-goods-wholesale-spec-select', goodsWholesaleSpecSelect)
Vue.component('nc-goods-store-recommend', goodsStoreRecommend)
Vue.component('nc-goods-combo', goodsCombo)
Vue.component('nc-goods-bundling', goodsBundling)
Vue.component('nc-goods-consult', goodsConsult)
Vue.component('nc-goods-book', goodsbook)
Vue.component('nc-goods-discount', goodsDiscount)
Vue.component("nc-buy-address", buyAddress)
Vue.component("nc-area-select-normal", areaSelectNormal)
Vue.component("nc-goods-contract", goodsContract)
Vue.component("nc-buy-payment", buyPayment)
Vue.component("nc-buy-invoice", buyInvoice)
Vue.component("nc-goods-chain", goodsChain)

Vue.component("nc-goods-reselect-wholesale",goodsReselectWholesale)
Vue.component("nc-goods-reselect",goodsReselect)

Vue.config.productionTip = false

Vue.config.devtools = true
window.Vue = Vue;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js